import { render, staticRenderFns } from "./WechatStatsCard.vue?vue&type=template&id=494a9490&"
import script from "./WechatStatsCard.vue?vue&type=script&lang=js&"
export * from "./WechatStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports